import { useState, useEffect } from 'react';

/**
 * Hook that delays the false/close transition by a specified duration.
 * Useful for keeping content visible during closing animations.
 *
 * @param {boolean} isOpen - The current open/close state
 * @param {number} delay - Delay in ms before transitioning to false (default: 300)
 * @returns {boolean} - Delayed state that transitions to false after the delay
 */
const useDelayedClose = (isOpen, delay = 300) => {
	const [delayedState, setDelayedState] = useState(isOpen);

	useEffect(() => {
		if (isOpen) {
			setDelayedState(true);
		} else {
			const timer = setTimeout(() => setDelayedState(false), delay);
			return () => clearTimeout(timer);
		}
	}, [isOpen, delay]);

	return delayedState;
};

export default useDelayedClose;
